<template>
    <div @keydown="progressbar.userKeyDown()" @keyup="progressbar.userKeyUp()" @click="calculate_progress">
        <h3 class="m-5 md:m-15 2xl:m-20">Accessibilité</h3>

        <div class="hidden text-lg text-gray-600 h-16 lg:h-24 2xl:h-32 font-normal lg:grid grid-cols-12 gap-x-4 place-content-center">
            <div class="col-span-7 ml-15">Intitulé</div>
            <div class="col-span-3 ">Nécessité</div>
            <div
                @mouseover="isDisplayCommentaireTooltip = true"
                @mouseleave="isDisplayCommentaireTooltip = false"
                class="col-span-1"
            >
                <info-bulle-hover
                    :is-display-tooltip="isDisplayCommentaireTooltip"
                    name="commentaireTooltip"
                    libelle="Commentaires"
                />
                Comm.
            </div>
        </div>

        <div class="flex flex-col space-y-4 lg:block px-2 lg:px-0">
            <!-- BEGIN Repérage des cheminements extérieurs -->
            <div class="h-auto lg:min-h-24 2xl:min-h-32 odd:bg-indigo-100 odd:bg-opacity-50 flex space-x-4 items-end lg:items-center lg:space-x-0 lg:grid grid-cols-12 gap-x-4 ">
                <label
class="hidden lg:block ml-15 col-span-7 text-base place-self-center justify-self-start"
                    for="reperage_cheminements_exterieurs"
                >
                    Repérage des cheminements extérieurs
                </label>
                <input-select
                    class="md:col-span-3 max-w-9/12"
                    name="reperage_cheminements_exterieurs"
                    :necessary="true"
                    :value="form.reperage_cheminements_exterieurs"
                    @input="(newValue) => {form.reperage_cheminements_exterieurs = newValue}"
                    :datas="[
                    {value: 'Nécessaire'},
                    {value: 'Inutile'},
                    ]"
                    :libelle="$isMobile() ? 'Repérage des cheminements extérieurs' : null"
                />
                <icon-comment
                    name="reperage_cheminements_exterieurs_comment"
                    :value="form.reperage_cheminements_exterieurs_comment" @input="(newValue) => {form.reperage_cheminements_exterieurs_comment = newValue}"
                    :necessary="true"
                    class="col-span-1 lg:place-self-center  w-max"
                />
            </div>
            <!-- END Repérage des cheminements extérieurs -->

            <!-- BEGIN Guidage des cheminements extérieurs -->
            <div class="h-auto lg:min-h-24 2xl:min-h-32 odd:bg-indigo-100 odd:bg-opacity-50 flex space-x-4 items-end lg:items-center lg:space-x-0 lg:grid grid-cols-12 gap-x-4 ">
                <label
class="hidden lg:block ml-15 col-span-7 text-base place-self-center justify-self-start"
                    for="guidage_cheminements_exterieurs"
                >
                    Guidage des cheminements extérieurs
                </label>
                <input-select
                    class="md:col-span-3 max-w-9/12"
                    name="guidage_cheminements_exterieurs"
                    :necessary="true"
                    :value="form.guidage_cheminements_exterieurs"
                    @input="(newValue) => {form.guidage_cheminements_exterieurs = newValue}"
                    :datas="[
                    {value: 'Nécessaire'},
                    {value: 'Inutile'},
                    ]"
                    :libelle="$isMobile() ? 'Guidage des cheminements extérieurs' : null"
                />
                <icon-comment
                    name="guidage_cheminements_exterieurs_comment"
                    :value="form.guidage_cheminements_exterieurs_comment" @input="(newValue) => {form.guidage_cheminements_exterieurs_comment = newValue}"
                    :necessary="true"
                    class="col-span-1 lg:place-self-center  w-max"
                />
            </div>
            <!-- END Guidage des cheminements extérieurs -->

            <!-- BEGIN Prévention d'éléments empiétant sur le chemin extérieur -->
            <div class="h-auto lg:min-h-24 2xl:min-h-32 odd:bg-indigo-100 odd:bg-opacity-50 flex space-x-4 items-end lg:items-center lg:space-x-0 lg:grid grid-cols-12 gap-x-4 ">
                <label
                    class="hidden lg:block ml-15 col-span-7 text-base  place-self-center justify-self-start mr-48"
                    for="prevention_element_chemin_exterieur"
                >
                    Prévention d'éléments empiétant sur le chemin extérieur (au dessus du sol, prés du sol, etc.)
                </label>

                <input-select
                    class="md:col-span-3 max-w-9/12"
                    name="prevention_element_chemin_exterieur"
                    :necessary="true"
                    :value="form.prevention_element_chemin_exterieur"
                    @input="(newValue) => {form.prevention_element_chemin_exterieur = newValue}"
                    :datas="[
                        {value: 'Nécessaire'},
                        {value: 'Inutile'},
                    ]"
                    :libelle="$isMobile() ? 'Prévention d\'éléments empiétant sur le chemin extérieur (au dessus du sol, prés du sol, etc.)' : null"
                />
                <icon-comment
                    name="prevention_element_chemin_exterieur_comment"
                    :value="form.prevention_element_chemin_exterieur_comment" @input="(newValue) => {form.prevention_element_chemin_exterieur_comment = newValue}"
                    :necessary="true"
                    class="col-span-1 lg:place-self-center  w-max"
                />
            </div>
            <!-- END Prévention d'éléments empiétant sur le chemin extérieur -->

            <!-- BEGIN Dispositifs de commande d'accès / sortie ou de communication -->
            <div class="h-auto lg:min-h-24 2xl:min-h-32 odd:bg-indigo-100 odd:bg-opacity-50 flex space-x-4 items-end lg:items-center lg:space-x-0 lg:grid grid-cols-12 gap-x-4 ">
                <label
                    class="hidden lg:block ml-15 col-span-7 text-base  place-self-center justify-self-start"
                    for="dispositifs_commande_acces"
                >
                    Dispositifs de commande d'accès / sortie ou de communication
                </label>
                <input-select
                    class="md:col-span-3 max-w-9/12"
                    name="dispositifs_commande_acces"
                    :necessary="true"
                    :value="form.dispositifs_commande_acces"
                    @input="(newValue) => {form.dispositifs_commande_acces = newValue}"
                    :datas="[
                    {value: 'Nécessaire'},
                    {value: 'Inutile'},
                    ]"
                    :libelle="$isMobile() ? 'Dispositifs de commande d\'accès / sortie ou de communication' : null"
                />
                <icon-comment
                    name="dispositifs_commande_acces_comment"
                    :value="form.dispositifs_commande_acces_comment" @input="(newValue) => {form.dispositifs_commande_acces_comment = newValue}"
                    :necessary="true"
                    class="col-span-1 lg:place-self-center  w-max"
                />
            </div>
            <!-- END Dispositifs de commande d'accès / sortie ou de communication -->

            <!-- BEGIN Dimensionnement des portes de circulation et des accès type sas -->
            <div
class="h-auto lg:min-h-24 2xl:min-h-32 odd:bg-indigo-100 odd:bg-opacity-50 flex space-x-4 items-end lg:items-center lg:space-x-0 lg:grid grid-cols-12 gap-x-4 flex-wrap"
                :class="{'h-auto pt-6': form.dimensionnement_portes_circulation == 'Nécessaire'}"
            >
                <label
                    class="hidden lg:block ml-15 col-span-7 text-base  place-self-center justify-self-start"
                    for="dimensionnement_portes_circulation"
                >
                    Dimensionnement des portes de circulation et des accès type sas
                </label>

                <input-select
                    class="md:col-span-3 max-w-9/12"
                    name="dimensionnement_portes_circulation"
                    :necessary="true"
                    :value="form.dimensionnement_portes_circulation"
                    @input="(newValue) => {form.dimensionnement_portes_circulation = newValue}"
                    :datas="[
                    {value: 'Nécessaire'},
                    {value: 'Inutile'},
                    ]"
                    :libelle="$isMobile() ? 'Dimensionnement des portes de circulation et des accès type sas' : null"
                />

                <icon-comment
                    name="dimensionnement_portes_circulation_comment"
                    :value="form.dimensionnement_portes_circulation_comment" @input="(newValue) => {form.dimensionnement_portes_circulation_comment = newValue}"
                    :necessary="true"
                    class="col-span-1 lg:place-self-center  w-max"
                />

                <transition
                    enter-active-class="ease-out duration-300"
                    enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enter-to-class="opacity-100 translate-y-0 sm:scale-100"
                    leave-active-class="ease-in duration-200"
                    leave-class="opacity-100 translate-y-0 sm:scale-100"
                    leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                    <div
                        v-if="form.dimensionnement_portes_circulation == 'Nécessaire'"
                        class="ml-20 my-6 col-start-1 col-span-full grid grid-cols-12 gap-4"
                    >
                        <checkbox-indigo
                            name="espace_manoeuvre_frontal"
                            libelle="Espace de manoeuvre frontal"
                            :value="form.espace_manoeuvre_frontal" @input="(newValue) => {form.espace_manoeuvre_frontal = newValue}"
                            class="col-span-10 md:col-span-5 md:ml-15"
                        />
                        <icon-comment
                            name="espace_manoeuvre_frontal_comment"
                            :value="form.espace_manoeuvre_frontal_comment" @input="(newValue) => {form.espace_manoeuvre_frontal_comment = newValue}"
                            :necessary="true"
                            class="col-span-2 md:col-span-1 md:place-self-center md:col-start-11 w-max"
                        />

                        <checkbox-indigo
                            name="espace_manoeuvre_lateral"
                            libelle="Espace de manoeuvre lateral"
                            :value="form.espace_manoeuvre_lateral" @input="(newValue) => {form.espace_manoeuvre_lateral = newValue}"
                            class="col-span-10 lg:col-start-1 md:col-span-5 md:ml-15"
                        />
                        <icon-comment
                            name="espace_manoeuvre_lateral_comment"
                            :value="form.espace_manoeuvre_lateral_comment" @input="(newValue) => {form.espace_manoeuvre_lateral_comment = newValue}"
                            :necessary="true"
                            class="col-span-2 md:col-span-1 md:place-self-center md:col-start-11 w-max"
                        />
                    </div>
                </transition>
            </div>
            <!-- END Dimensionnement des portes de circulation et des accès type sas -->

            <!-- BEGIN Repérage des portes et poignées -->
            <div
                class="h-auto lg:min-h-24 2xl:min-h-32 odd:bg-indigo-100 odd:bg-opacity-50 flex space-x-4 items-end lg:items-center lg:space-x-0 lg:grid grid-cols-12 gap-x-4 flex-wrap"
                :class="{'h-auto pt-6': form.reperage_portes_poignees == 'Nécessaire'}"
            >
                <label
                    class="hidden lg:block ml-15 col-span-7 text-base  place-self-center justify-self-start"
                    for="reperage_portes_poignees"
                >
                    Repérage des portes et poignées
                </label>

                <input-select
                    class="md:col-span-3 max-w-9/12"
                    name="reperage_portes_poignees"
                    :necessary="true"
                    :value="form.reperage_portes_poignees"
                    @input="(newValue) => {form.reperage_portes_poignees = newValue}"
                    :datas="[
                    {value: 'Nécessaire'},
                    {value: 'Inutile'},
                    ]"
                    :libelle="$isMobile() ? 'Repérage des portes et poignées' : null"
                />

                <icon-comment
                    name="reperage_portes_poignees_comment"
                    :value="form.reperage_portes_poignees_comment" @input="(newValue) => {form.reperage_portes_poignees_comment = newValue}"
                    :necessary="true"
                    class="col-span-1 lg:place-self-center  w-max"
                />

                <transition
                    enter-active-class="ease-out duration-300"
                    enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enter-to-class="opacity-100 translate-y-0 sm:scale-100"
                    leave-active-class="ease-in duration-200"
                    leave-class="opacity-100 translate-y-0 sm:scale-100"
                    leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                    <div
v-if="form.reperage_portes_poignees == 'Nécessaire'"
                        class="ml-20 my-6 col-span-full grid grid-cols-12 gap-4"
                    >
                        <checkbox-indigo
                            name="contraste_environnement"
                            libelle="Contraste par rapport à l'environnement"
                            :value="form.contraste_environnement" @input="(newValue) => {form.contraste_environnement = newValue}"
                            class="col-span-10 lg:col-start-1 md:col-span-5 md:ml-15"

                        />
                        <icon-comment
                            name="contraste_environnement_comment"
                            :value="form.contraste_environnement_comment" @input="(newValue) => {form.contraste_environnement_comment = newValue}"
                            :necessary="true"
                            class="col-span-2 md:col-span-1 md:place-self-center md:col-start-11 w-max"
                        />

                        <checkbox-indigo
                            name="espace_manoeuvre"
                            libelle="Espace de Manoeuvre"
                            :value="form.espace_manoeuvre" @input="(newValue) => {form.espace_manoeuvre = newValue}"
                            class="col-span-10 lg:col-start-1 md:col-span-5 md:ml-15"

                        />
                        <icon-comment
                            name="espace_manoeuvre_comment"
                            :value="form.espace_manoeuvre_comment" @input="(newValue) => {form.espace_manoeuvre_comment = newValue}"
                            :necessary="true"
                            class="col-span-2 md:col-span-1 md:place-self-center md:col-start-11 w-max"
                        />

                        <checkbox-indigo
                            name="poignees_prehensible_assise"
                            libelle="Poignée préhensible en position assise"
                            :value="form.poignees_prehensible_assise" @input="(newValue) => {form.poignees_prehensible_assise = newValue}"
                            class="col-span-10 lg:col-start-1 md:col-span-5 md:ml-15"

                        />
                        <icon-comment
                            name="poignees_prehensible_assise_comment"
                            :value="form.poignees_prehensible_assise_comment" @input="(newValue) => {form.poignees_prehensible_assise_comment = newValue}"
                            :necessary="true"
                            class="col-span-2 md:col-span-1 md:place-self-center md:col-start-11 w-max"
                        />

                        <checkbox-indigo
                            name="poignee_prehensible_droite"
                            libelle="Poignée préhensible droite"
                            :value="form.poignee_prehensible_droite" @input="(newValue) => {form.poignee_prehensible_droite = newValue}"
                            class="col-span-10 lg:col-start-1 md:col-span-5 md:ml-15"

                        />
                        <icon-comment
                            name="poignee_prehensible_droite_comment"
                            :value="form.poignee_prehensible_droite_comment" @input="(newValue) => {form.poignee_prehensible_droite_comment = newValue}"
                            :necessary="true"
                            class="col-span-2 md:col-span-1 md:place-self-center md:col-start-11 w-max"
                        />

                        <checkbox-indigo
                            name="poignee_prehensible_gauche"
                            libelle="Poignée préhensible gauche"
                            :value="form.poignee_prehensible_gauche" @input="(newValue) => {form.poignee_prehensible_gauche = newValue}"
                            class="col-span-10 lg:col-start-1 md:col-span-5 md:ml-15"

                        />
                        <icon-comment
                            name="poignee_prehensible_gauche_comment"
                            :value="form.poignee_prehensible_gauche_comment" @input="(newValue) => {form.poignee_prehensible_gauche_comment = newValue}"
                            :necessary="true"
                            class="col-span-2 md:col-span-1 md:place-self-center md:col-start-11 w-max"
                        />
                    </div>
                </transition>
            </div>
            <!-- END Repérage des portes et poignées -->

            <!-- BEGIN Montées de marches -->
            <div class="h-auto lg:min-h-24 2xl:min-h-32 odd:bg-indigo-100 odd:bg-opacity-50 flex space-x-4 items-end lg:items-center lg:space-x-0 lg:grid grid-cols-12 gap-x-4 ">

                <label
                    class="hidden lg:block ml-15 col-span-7 text-base  place-self-center justify-self-start"
                    for="montees_marches"
                >
                    Montées de marches
                </label>

                <input-select
                    class="md:col-span-3 max-w-9/12"
                    name="montees_marches"
                    :necessary="true"
                    :value="form.montees_marches"
                    @input="(newValue) => {form.montees_marches = newValue}"
                    :datas="[
                    {value: 'Possible'},
                    {value: 'Impossible'},
                    {value: 'Rampe d\'accès amovible obligatoire'},
                    ]"
                    :libelle="$isMobile() ? 'Montées de marches' : null"
                />
                <icon-comment
                    name="montees_marches_comment"
                    :value="form.montees_marches_comment" @input="(newValue) => {form.montees_marches_comment = newValue}"
                    :necessary="true"
                    class="col-span-1 lg:place-self-center  w-max"
                />
            </div>
            <!-- END Montées de marches -->

            <!-- BEGIN Montées d'escaliers -->
            <div class="h-auto lg:min-h-24 2xl:min-h-32 odd:bg-indigo-100 odd:bg-opacity-50 flex space-x-4 items-end lg:items-center lg:space-x-0 lg:grid grid-cols-12 gap-x-4 ">

                <label
                    class="hidden lg:block ml-15 col-span-7 text-base  place-self-center justify-self-start"
                    for="montees_escaliers"
                >
                    Montées d'escaliers
                </label>

                <input-select
                    class="md:col-span-3 max-w-9/12"
                    name="montees_escaliers"
                    :necessary="true"
                    :value="form.montees_escaliers"
                    @input="(newValue) => {form.montees_escaliers = newValue}"
                    :datas="[
                    {value: 'Possible'},
                    {value: 'Impossible'},
                    {value: 'Main courante obligatoire'},
                    {value: 'Rampe d\'accès amovible obligatoire'}
                    ]"
                    :libelle="$isMobile() ? 'Montées d\'escaliers' : null"
                />
                <icon-comment
                    name="montees_escaliers_comment"
                    :value="form.montees_escaliers_comment" @input="(newValue) => {form.montees_escaliers_comment = newValue}"
                    :necessary="true"
                    class="col-span-1 lg:place-self-center  w-max"
                />
            </div>
            <!-- END Montées d'escaliers -->

            <!-- BEGIN Prévention d'éléments empiétant sur le cheminement intérieur -->
            <div class="h-auto lg:min-h-24 2xl:min-h-32 odd:bg-indigo-100 odd:bg-opacity-50 flex space-x-4 items-end lg:items-center lg:space-x-0 lg:grid grid-cols-12 gap-x-4 ">

                <label
                    class="hidden lg:block ml-15 col-span-7 text-base  place-self-center justify-self-start"
                    for="prevention_elements_chemin_interieur"
                >
                    Prévention d'éléments empiétant sur le cheminement intérieur <br /> (au-dessus du sol, près du sol, latéral, etc...)
                </label>

                <input-select
                    class="md:col-span-3 max-w-9/12"
                    name="prevention_elements_chemin_interieur"
                    :necessary="true"
                    :value="form.prevention_elements_chemin_interieur"
                    @input="(newValue) => {form.prevention_elements_chemin_interieur = newValue}"
                    :datas="[
                    {value: 'Nécessaire'},
                    {value: 'Inutile'},
                    ]"
                    :libelle="$isMobile() ? 'Prévention d\'éléments empiétant sur le cheminement intérieur (au-dessus du sol, près du sol, latéral, etc...)' : null"
                />
                <icon-comment
                    name="prevention_elements_chemin_interieur_comment"
                    :value="form.prevention_elements_chemin_interieur_comment" @input="(newValue) => {form.prevention_elements_chemin_interieur_comment = newValue}"
                    :necessary="true"
                    class="col-span-1 lg:place-self-center  w-max"
                />
            </div>
            <!-- BEGIN Prévention d'éléments empiétant sur le cheminement intérieur -->

            <!-- BEGIN Information et signalisation intérieure -->
            <div class="h-auto lg:min-h-24 2xl:min-h-32 odd:bg-indigo-100 odd:bg-opacity-50 flex space-x-4 items-end lg:items-center lg:space-x-0 lg:grid grid-cols-12 gap-x-4 ">

                <label
                    class="hidden lg:block ml-15 col-span-7 text-base  place-self-center justify-self-start"
                    for="information_signalisation_interieure"
                >
                    Information et signalisation intérieure
                </label>

                <input-select
                    class="md:col-span-3 max-w-9/12"
                    name="information_signalisation_interieure"
                    :necessary="true"
                    :value="form.information_signalisation_interieure"
                    @input="(newValue) => {form.information_signalisation_interieure = newValue}"
                    :datas="[
                    {value: 'Nécessaire'},
                    {value: 'Inutile'},
                    ]"
                    :libelle="$isMobile() ? 'Information et signalisation intérieure' : null"
                />
                <icon-comment
                    name="information_signalisation_interieure_comment"
                    :value="form.information_signalisation_interieure_comment" @input="(newValue) => {form.information_signalisation_interieure_comment = newValue}"
                    :necessary="true"
                    class="col-span-1 lg:place-self-center  w-max"
                />
            </div>
            <!-- END Information et signalisation intérieure -->
            
            <!-- BEGIN Ascenseur adapté/ EPMR Vertical -->
            <div class="h-auto lg:min-h-24 2xl:min-h-32 odd:bg-indigo-100 odd:bg-opacity-50 flex space-x-4 items-end lg:items-center lg:space-x-0 lg:grid grid-cols-12 gap-x-4 ">
                <label
                    class="hidden lg:block ml-15 col-span-7 text-base  place-self-center justify-self-start"
                    for="EPMR_vertical"
                >
                    Ascenseur adapté/ EPMR Vertical (Elévateur pour Personnes à Mobilité Réduite)
                </label>

                <input-select
                    class="md:col-span-3 max-w-9/12"
                    name="EPMR_vertical"
                    :necessary="true"
                    :value="form.EPMR_vertical"
                    @input="(newValue) => {form.EPMR_vertical = newValue}"
                    :datas="[
                    {value: 'Nécessaire'},
                    {value: 'Inutile'},
                    ]"
                    :libelle="$isMobile() ? 'Ascenseur adapté/ EPMR Vertical (Elévateur pour Personnes à Mobilité Réduite)' : null"
                />
                <icon-comment
                    name="EPMR_vertical_comment"
                    :value="form.EPMR_vertical_comment" @input="(newValue) => {form.EPMR_vertical_comment = newValue}"
                    :necessary="true"
                    class="col-span-1 lg:place-self-center  w-max"
                />
            </div>
            <!-- END Ascenseur adapté/ EPMR Vertical -->

            <!-- BEGIN Aménagement Toilettes -->
            <div
class="h-auto lg:min-h-24 2xl:min-h-32 odd:bg-indigo-100 odd:bg-opacity-50 flex space-x-4 items-end lg:items-center lg:space-x-0 lg:grid grid-cols-12 gap-x-4 flex-wrap"
                :class="{'h-auto pt-6': form.amenagement_toilettes == 'Nécessaire'}"
            >

                <label
                    class="hidden lg:block ml-15 col-span-7 text-base  place-self-center justify-self-start"
                    for="amenagement_toilettes"
                >
                    Aménagement Toilettes
                </label>

                <input-select
                    class="md:col-span-3 max-w-9/12"
                    name="amenagement_toilettes"
                    :necessary="true"
                    :value="form.amenagement_toilettes"
                    @input="(newValue) => {form.amenagement_toilettes = newValue}"
                    :datas="[
                    {value: 'Nécessaire'},
                    {value: 'Inutile'},
                    ]"
                    :libelle="$isMobile() ? 'Aménagement Toilettes' : null"
                />
                <icon-comment
                    name="amenagement_toilettes_comment"
                    :value="form.amenagement_toilettes_comment" @input="(newValue) => {form.amenagement_toilettes_comment = newValue}"
                    :necessary="true"
                    class="col-span-1 lg:place-self-center  w-max"
                />

                <transition
                    enter-active-class="ease-out duration-300"
                    enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enter-to-class="opacity-100 translate-y-0 sm:scale-100"
                    leave-active-class="ease-in duration-200"
                    leave-class="opacity-100 translate-y-0 sm:scale-100"
                    leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                    <div
                        v-if="form.amenagement_toilettes == 'Nécessaire'"
                        class="ml-20 my-6 col-span-full grid grid-cols-12 gap-4"
                    >
                        <checkbox-indigo
                            name="espace_transfert_frontal"
                            libelle="Espace de transfert frontal"
                            :value="form.espace_transfert_frontal" @input="(newValue) => {form.espace_transfert_frontal = newValue}"
                            class="col-span-10 lg:col-start-1 md:col-span-5 md:ml-15"

                        />
                        <icon-comment
                            name="espace_transfert_frontal_comment"
                            :value="form.espace_transfert_frontal_comment" @input="(newValue) => {form.espace_transfert_frontal_comment = newValue}"
                            :necessary="true"
                            class="col-span-2 md:col-span-1 md:place-self-center md:col-start-11 w-max"
                        />

                        <checkbox-indigo
                            name="espace_transfert_lateral"
                            libelle="Espace de transfert latéral"
                            :value="form.espace_transfert_lateral" @input="(newValue) => {form.espace_transfert_lateral = newValue}"
                            class="col-span-10 lg:col-start-1 md:col-span-5 md:ml-15"

                        />
                        <icon-comment
                            name="espace_transfert_lateral_comment"
                            :value="form.espace_transfert_lateral_comment" @input="(newValue) => {form.espace_transfert_lateral_comment = newValue}"
                            :necessary="true"
                            class="col-span-2 md:col-span-1 md:place-self-center md:col-start-11 w-max"
                        />

                        <checkbox-indigo
                            name="hauteur_wc_respecter"
                            libelle="Hauteur des WC à respecter (Abattant inclus)"
                            :value="form.hauteur_wc_respecter" @input="(newValue) => {form.hauteur_wc_respecter = newValue}"
                            class="col-span-10 lg:col-start-1 md:col-span-5 md:ml-15"

                        />
                        <icon-comment
                            name="hauteur_wc_respecter_comment"
                            :value="form.hauteur_wc_respecter_comment" @input="(newValue) => {form.hauteur_wc_respecter_comment = newValue}"
                            :necessary="true"
                            class="col-span-2 md:col-span-1 md:place-self-center md:col-start-11 w-max"
                        />
                    </div>
                </transition>
            </div>
            <!-- END Aménagement Toilettes -->
        </div>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';
import InputText from '../../../components/Inputs/InputText';
import InputTextArea from '../../../components/Inputs/InputTextArea';
import InputSelect from '../../../components/Inputs/InputSelect';
import MultipleSelect from '../../../components/Inputs/MultipleSelect';
import DatePicker from '../../../components/Inputs/DatePicker';
import CheckboxGreen from '../../../components/Inputs/CheckboxGreen';
import CheckboxForm from '../../../components/Inputs/CheckboxForm';
import Icon from '../../../components/Icon';
import CheckboxIndigo from'../../../components/Inputs/CheckboxIndigo';
import IconComment from'../../../components/Inputs/IconComment';
import InfoBulleHover from './../../../components/InfoBulleHover.vue';

export default {
  components: {
    InputText,
    InputTextArea,
    InputSelect,
    MultipleSelect,
    DatePicker,
    CheckboxGreen,
    CheckboxForm,
    Icon,
    CheckboxIndigo,
    IconComment,
    InfoBulleHover,
  },

  props:['progressbar'],

  name: 'Accessibilité',

  data() {
    return {
      isDisplayCommentaireTooltip:false,
      // Initial state of the form
      form: {
        reperage_cheminements_exterieurs: '',
        reperage_cheminements_exterieurs_comment:'',
        guidage_cheminements_exterieurs: '',
        guidage_cheminements_exterieurs_comment:'',
        prevention_element_chemin_exterieur: '',
        prevention_element_chemin_exterieur_comment:'',
        dispositifs_commande_acces: '',
        dispositifs_commande_acces_comment:'',
        dimensionnement_portes_circulation: '',
        dimensionnement_portes_circulation_comment:'',
        espace_manoeuvre_frontal: false,
        espace_manoeuvre_frontal_comment:'',
        espace_manoeuvre_lateral:false,
        espace_manoeuvre_lateral_comment:'',
        reperage_portes_poignees:'',
        reperage_portes_poignees_comment:'',
        contraste_environnement:false,
        contraste_environnement_comment:'',
        espace_manoeuvre:false,
        espace_manoeuvre_comment:'',
        poignees_prehensible_assise:false,
        poignees_prehensible_assise_comment:'',
        poignee_prehensible_droite:false,
        poignee_prehensible_droite_comment:'',
        poignee_prehensible_gauche:false,
        poignee_prehensible_gauche_comment:'',
        montees_marches:'',
        montees_marches_comment:'',
        montees_escaliers:'',
        montees_escaliers_comment:'',
        prevention_elements_chemin_interieur:'',
        prevention_elements_chemin_interieur_comment:'',
        information_signalisation_interieure:'',
        information_signalisation_interieure_comment:'',
        EPMR_vertical:'',
        EPMR_vertical_comment:'',
        amenagement_toilettes:'',
        amenagement_toilettes_comment:'',
        espace_transfert_frontal:false,
        espace_transfert_frontal_comment:'',
        espace_transfert_lateral:false,
        espace_transfert_lateral_comment:'',
        hauteur_wc_respecter:false,
        hauteur_wc_respecter_comment:'',
      },
      nameDisplayCom: '',

    };
  },
    
  async mounted() {
    await this.initForm(); // asynchrone function to wait do actions, then re-pass isFormChanged to false (actions in form pass this var to true)
    this.calculate_progress();
    this.infosPage.isFormChanged = false; // here, change value of isFormChanged to false to indicate that there is not change in form
  },

  methods: {
    ...mapMutations({
      SET_FORMCONTENT: 'neopass/SET_FORMCONTENT',
      calculate_progress: 'neopass/calculate_progress',
      SET_INFOSPAGES: 'neopass/SET_INFOSPAGE',
    }),

    initForm(){
      //load values in form and keep formContent with initial values to compare when leave page without saving
      Object.assign(this.form, this.formContent);
    },

  },
  computed: {
    ...mapGetters({
      formContent: 'neopass/formContent',
      infosPage: 'neopass/infosPage',
    }),
  },
  watch: {

    form: {
      handler() {
        //assign true to flag to know if there is a change in form
        this.infosPage.isFormChanged = true;
      },

      deep: true,
    },
  },
};
</script>
